import React from "react"

// @ts-ignore
import TabsSelector from "../../../../../../../../src/core/gd-components/tabs-selector/tabs-selector"

type Props = {
    advanced        : boolean

    onSwitchAdvanced: func
}

export default function AdvancedSwitch(props:Props) {
    const options = [
        { title: 'Simple',      id: 'simple',   width: 60 },
        { title: 'Advanced',    id: 'advanced', width: 70 },
    ];

    return <TabsSelector className      = "option-button"
                         skin           = "menu"
                         items          = {options}
                         selectedId     = {props.advanced ? 'advanced' : 'simple'}
                         onSelectTab    = {props.onSwitchAdvanced}/>;
}